import React, { createContext, useContext, useState, ReactNode } from 'react';

interface QuickDeleteContextType {
  quickDeleteEnabled: boolean;
  setQuickDeleteEnabled: (enabled: boolean) => void;
}

const QuickDeleteContext = createContext<QuickDeleteContextType | undefined>(undefined);

export const QuickDeleteProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [quickDeleteEnabled, setQuickDeleteEnabled] = useState(false);

  return (
    <QuickDeleteContext.Provider value={{ quickDeleteEnabled, setQuickDeleteEnabled }}>
      {children}
    </QuickDeleteContext.Provider>
  );
};

export const useQuickDelete = () => {
  const context = useContext(QuickDeleteContext);
  if (context === undefined) {
    throw new Error('useQuickDelete must be used within a QuickDeleteProvider');
  }
  return context;
};
